<template>
  <svg
    class="icon"
    :aria-hidden="hidden"
    :color="color"
  >
    <use :xlink:href="type" />
  </svg>
</template>
<script>
/**
 *@overview:iconfont svg使用封装
 *@author [damon song]
 *@createDate [2020-06-26]
 *@example <Sicon class="sicon" type="#icon-xiugaimima" />
 *@param {String} type -font的值
 *@param {String} color -设置颜色
 *@param {String} class -设置样式
 */
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    hidden: {
      type: Boolean,
      default: true
    },
    color: {
      type: String
    }
  }
}
</script>
<style lang="less" scoped>
.icon {
  height: 22px;
  width: 22px;
  fill: currentColor;
  overflow: hidden;
}
</style>
